PartsMainController.$inject = []
function PartsMainController(){

}

export default PartsMainController